// Report-definition for the Reconciliation Status Report.
// columns[] is the single source of truth for column order, labels, types, totals, drill.
export const reconciliation_status = {
   id: "reconciliation_status",
   title: "Reconciliation Status",
   family: "reconciliation_status",
   endpoint: "/runreconstatus.sz", // dedicated .sz page (no in-query branching)
   defaultSort: { key: "remaining", dir: "desc" },
   groupBy: ["match_status"],
   groupOptions: [
      { value: "match_status", label: "Status" },
      { value: "supplier",     label: "Supplier" },
      { value: "location",     label: "Location" },
   ],
   categoryField: "match_status",
   categoryLabel: "Status",
   minField: "statement_amount",
   minLabel: "Min statement $",
   params: [
      { key: "period",      type: "month",       label: "Period" },
      { key: "locations",   type: "multiselect", label: "Locations" },
      { key: "suppliers",   type: "multiselect", label: "Suppliers" },
      { key: "minVariance", type: "number",      label: "Min $" },
   ],
   summary: [
      { key: "lines",       label: "Lines",         type: "int",   agg: "count" },
      { key: "reconciled",  label: "Reconciled",    type: "int",   agg: "countWhere", column: "match_status", equals: "FULL_MATCH" },
      { key: "outstanding", label: "$ Outstanding", type: "money", agg: "sum",        column: "remaining" },
   ],
   columns: [
      { key: "supplier",         label: "Supplier",    type: "text",  align: "left" },
      { key: "location",         label: "Location",    type: "text",  align: "left" },
      { key: "invoice_no",       label: "Invoice #",   type: "text",  align: "left",  drill: "pair" },
      { key: "statement_date",   label: "Statement date", type: "date",  align: "left" },
      { key: "statement_amount", label: "Statement $", type: "money", align: "right", total: "sum" },
      { key: "allocated",        label: "Allocated $", type: "money", align: "right", total: "sum" },
      { key: "remaining",        label: "Remaining $", type: "money", align: "right", total: "sum" },
      { key: "match_status",     label: "Status",      type: "label", align: "left" },
   ],
};
